import React, { useState, useEffect } from 'react';
import API from '../../api/API';
import './AGruppi.css';

const AGruppi = () => {
  const [gruppi, setGruppi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newGruppoNome, setNewGruppoNome] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchGruppi();
  }, []);

  const fetchGruppi = async () => {
    const res = await API.gruppo.getAll();
    if (res.isSuccess) {
      setGruppi(res.data || []);
    }
    setLoading(false);
  };

  const handleAdd = async () => {
    if (!newGruppoNome.trim()) return;
    setAdding(true);
    const res = await API.gruppo.create({ nome: newGruppoNome.trim() });
    if (res.isSuccess) {
      setNewGruppoNome('');
      fetchGruppi();
    } else {
      alert('Errore durante la creazione del gruppo');
    }
    setAdding(false);
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Sei sicuro di voler eliminare "${name}"?`)) return;
    const res = await API.gruppo.delete(id);
    if (res.isSuccess) {
      setGruppi(prev => prev.filter(g => g.id !== id));
    } else {
      alert('Errore durante l\'eliminazione del gruppo');
    }
  };

  if (loading) {
    return (
      <div className="gruppi-page">
        <div className="gruppi-loading">
          <div className="loading-spinner"></div>
          <p>Caricamento in corso...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gruppi-container">
      <div className="gruppi-header">
        <div className="gruppi-title">
          <i className="fas fa-campground"></i>
          <h1>Gestione Gruppi Scout</h1>
        </div>
        <div className="gruppi-stats">
          <div className="gruppi-stat">
            <i className="fas fa-users"></i>
            <span>Totale: </span>
            <span className="gruppi-counter">{gruppi.length}</span>
          </div>
        </div>
      </div>

      <div className="gruppi-add-section">
        <div className="gruppi-add-form">
          <input
            type="text"
            value={newGruppoNome}
            onChange={(e) => setNewGruppoNome(e.target.value)}
            placeholder="Nome del nuovo gruppo scout..."
            className="gruppi-add-input"
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          />
          <button
            onClick={handleAdd}
            disabled={adding || !newGruppoNome.trim()}
            className="btn btn-primary gruppi-add-btn"
          >
            {adding ? (
              <><div className="loading-spinner-small"></div> Aggiunta...</>
            ) : (
              <><i className="fas fa-plus"></i> Aggiungi</>
            )}
          </button>
        </div>
      </div>

      {gruppi.length > 0 ? (
        <div className="gruppi-table-container">
          <table className="gruppi-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {gruppi.map(gruppo => (
                <tr key={gruppo.id}>
                  <td>{gruppo.id}</td>
                  <td><strong>{gruppo.name}</strong></td>
                  <td>
                    <button
                      className="btn btn-delete btn-sm"
                      onClick={() => handleDelete(gruppo.id, gruppo.name)}
                      title="Elimina gruppo"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="gruppi-empty">
          <i className="fas fa-info-circle"></i>
          <p>Nessun gruppo scout presente. Aggiungi il primo!</p>
        </div>
      )}
    </div>
  );
};

export default AGruppi;
